import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaArrowLeft,
  FaAward,
  FaDownload,
  FaExternalLinkAlt,
  FaCopy,
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import axios from 'axios';
import api from '../../api';
import { useAuth } from '../../context/AuthContext';
import Loader from '../../components/Loader/Loader';
import './CertificatePage.css';

const CertificatePage = () => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [loading, setLoading] = useState(true);
  const [certificates, setCertificates] = useState([]);

  const fetchCertificates = useCallback(async () => {
    try {
      const res = await axios.get(`${api.baseURL}/api/exams/certificates/my`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) setCertificates(res.data.data);
    } catch (error) {
      console.error('Error fetching certificates:', error);
      toast.error('Failed to load certificates');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchCertificates();
  }, [fetchCertificates]);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast.success('Certificate number copied!');
  };

  if (loading) return <Loader message="Loading certificates..." />;

  return (
    <div className="cert-page">
      <header className="cert-header">
        <button className="cert-back-btn" onClick={() => navigate('/university/dashboard')}>
          <FaArrowLeft /> Back
        </button>
        <h1>My Certificates</h1>
        <div></div>
      </header>

      {certificates.length === 0 ? (
        <div className="cert-empty">
          <FaAward className="cert-empty-icon" />
          <h2>No Certificates Yet</h2>
          <p>Pass exams with 45% or above to earn certificates!</p>
          <button className="cert-start-btn" onClick={() => navigate('/university/exam')}>
            Take an Exam
          </button>
        </div>
      ) : (
        <div className="cert-list">
          {certificates.map((cert) => (
            <div key={cert._id} className="cert-card">
              <div className="cert-card-header">
                <FaAward className="cert-award-icon" />
                <div className="cert-card-title">
                  <h3>{cert.subject}</h3>
                  <span className="cert-category">{cert.category}</span>
                </div>
                <span className={`cert-grade cert-grade-${cert.grade.replace('+', 'plus')}`}>
                  {cert.grade}
                </span>
              </div>
              <div className="cert-card-body">
                <div className="cert-detail">
                  <span className="cert-label">Certificate Number</span>
                  <span className="cert-value cert-number">
                    {cert.certificateNumber}
                    <button className="cert-copy-btn" onClick={() => copyToClipboard(cert.certificateNumber)}>
                      <FaCopy />
                    </button>
                  </span>
                </div>
                <div className="cert-detail">
                  <span className="cert-label">Score</span>
                  <span className="cert-value">{cert.percentage?.toFixed(0)}%</span>
                </div>
                <div className="cert-detail">
                  <span className="cert-label">Level</span>
                  <span className={`cert-value cert-diff-${cert.level}`}>{cert.level}</span>
                </div>
                <div className="cert-detail">
                  <span className="cert-label">Issued</span>
                  <span className="cert-value">{new Date(cert.issuedAt).toLocaleDateString()}</span>
                </div>
              </div>
              <div className="cert-card-footer">
                <button
                  className="cert-view-btn"
                  onClick={() => navigate(`/university/result/${cert.examId}`)}
                >
                  <FaExternalLinkAlt /> View Exam
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CertificatePage;
